import Button from 'components/Button'
import Flex from 'components/Flex'
import Group from 'components/Images/Group.png'
import { Heading, Para } from 'modules/Drives/ViewDrive/Style/style'
import React from 'react'

const RequestConformDrawer = ({ setConfirmDrawer }) => {
  const onClose = () => {
    setConfirmDrawer(false)
  }
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: '195px',
      }}
    >
      <Flex>
        <img src={Group} alt="requestIcon" />
      </Flex>
      <Flex
        column
        style={{
          marginTop: '10px',
        }}
      >
        <Heading center>Request Sent Successfully</Heading>
        <Para>Following Document request has been sent successfully</Para>
      </Flex>
      <div
        style={{
          marginTop: '30px',
        }}
      >
        <Button.Secondary text="Close" height="38px" onClick={onClose} />
      </div>
    </div>
  )
}

export default RequestConformDrawer
